export const GUEST_POPUP_DELAY = 25_000;
export const GUEST_POPUP_PAUSE = 3 * 24 * 60 * 60 * 1000;
export const GUEST_POPUP_VISIT_KEY = "td_guest_popup_shown";
export const GUEST_POPUP_KEYS = {
  install: "td_guest_install_popup_until",
  signup: "td_guest_signup_popup_until",
};
export type GuestPopupKind = keyof typeof GUEST_POPUP_KEYS;

export function guestPopupReady(elapsed: number, openedCards: number, blocked: boolean): boolean {
  return !blocked && (elapsed >= GUEST_POPUP_DELAY || openedCards >= 2);
}

export function selectGuestPopup({
  now, skipInstall, installUntil, signupUntil, shown, storageAvailable,
}: {
  now: number;
  skipInstall: boolean;
  installUntil: number;
  signupUntil: number;
  shown: boolean;
  storageAvailable: boolean;
}): GuestPopupKind | null {
  if (!storageAvailable || shown) return null;
  if (signupUntil <= now) return "signup";
  if (!skipInstall && installUntil <= now) return "install";
  return null;
}